import { apiClient } from './_shared.js'

// ============================================
// DIRECT CHATS (PERSONAL CHATS)
// ============================================

export async function getDirectChatRooms(orgId, userId) {
  return await apiClient(`/direct-chat/rooms?orgId=${orgId}&userId=${userId}`)
}

export async function createDirectChatRoom(user1Id, user2Id, orgId) {
  return await apiClient('/direct-chat/rooms', {
    method: 'POST',
    body: JSON.stringify({
      user1Id,
      user2Id,
      orgId,
      user1_id: user1Id,
      user2_id: user2Id,
      org_id: orgId
    })
  })
}

export async function getDirectMessages(roomId) {
  const data = await apiClient(`/direct-chat/messages/${roomId}`)
  return data.map(msg => ({
    ...msg,
    attachments: typeof msg.attachments === 'string' ? JSON.parse(msg.attachments) : msg.attachments
  }))
}

export async function sendDirectMessage(roomId, senderId, content, attachments = [], replyTo = null) {
  return await apiClient('/direct-chat/messages', {
    method: 'POST',
    body: JSON.stringify({ room_id: roomId, sender_id: senderId, content, attachments, reply_to: replyTo })
  })
}

export async function updateDirectMessage(msgId, content) {
  return await apiClient(`/direct-chat/messages/${msgId}`, {
    method: 'PUT',
    body: JSON.stringify({ content })
  })
}

export async function deleteDirectMessage(msgId) {
  return await apiClient(`/direct-chat/messages/${msgId}`, {
    method: 'DELETE'
  })
}

export async function markDirectMessagesAsRead(roomId, userId) {
  return await apiClient('/direct-chat/mark-read', {
    method: 'POST',
    body: JSON.stringify({ roomId, userId })
  })
}
